import { TEST_IDS } from '@va/constants';
import { useLocale, useTranslate } from '@va/localization';
import { fontWeights, Paragraph, paragraphSizes } from '@va/ui/design-system';
import { TooltipWrapper } from '@va/ui/tooltips';
import { addNumberSeparator, getPercentageColors } from '@va/util/helpers';
import classNames from 'classnames';
import Skeleton from 'react-loading-skeleton';

export function ReportBlockNumericHeading({
  value,
  percentageChange,
  isLoading = false,
  reversePercentageColors = true,
}: {
  value: string;
  percentageChange?: number;
  isLoading?: boolean;
  reversePercentageColors?: boolean;
}) {
  const { locale } = useLocale();
  const translate = useTranslate();
  return (
    <div className='flex flex-col items-center text-center relative'>
      <Paragraph
        data-testid={TEST_IDS.generic.dashboardCard.heading}
        className='w-full text-5xl! leading-54!'
        weight={fontWeights.semibold}
      >
        {isLoading ? <Skeleton /> : value}
      </Paragraph>
      {percentageChange !== undefined && (
        <Paragraph
          size={paragraphSizes.large}
          weight={fontWeights.medium}
          colorClassName={classNames(getPercentageColors(percentageChange, reversePercentageColors))}
          className='p-3 w-full'
        >
          {isLoading ? (
            <Skeleton />
          ) : (
            <TooltipWrapper content={translate('percentComparedToPrevious')}>
              <span
                data-testid={TEST_IDS.generic.dashboardCard.percentageChange}
                className={classNames(getPercentageColors(percentageChange, reversePercentageColors))}
              >
                {addNumberSeparator(percentageChange, locale, {
                  style: 'percent',
                  signDisplay: 'exceptZero',
                })}
              </span>
            </TooltipWrapper>
          )}
        </Paragraph>
      )}
    </div>
  );
}
